import { ReactNode } from "react";
import pacmanLeft from "@assets/img/pacmanBackgroundLeft.png";
import pacmanRight from "@assets/img/pacmanBackgroundRight.png";
import "./AlloweatLayout.scss";

const AlloweatLayout = (props: { children: ReactNode }) => {
  return (
    <>
      <div className="d-flex d-justify-space-between auth-alloweat-layout__bg">
        <img alt="" className="auth-alloweat-layout__bg-img" src={pacmanLeft} />
        <img
          alt=""
          className="auth-alloweat-layout__bg-img"
          src={pacmanRight}
        />
      </div>
      {props.children}
    </>
  );
};

export default AlloweatLayout;
